import _isNumber from "lodash/isNumber";
import { getCostForState } from './helpers';
/**
 * Gets the yearly property tax rate
 * @param {number=} monthlyPropertyTax Override for monthly property tax
 * @param {string} stateAbbr  2 character US state abbreviation
 * @param {number} suggestedPurchasePrice  purchase price of home
 * @returns {number} The yearly property tax
 */

export default function getYearlyPropertyTax(monthlyPropertyTax, stateAbbr, suggestedPurchasePrice) {
  if (_isNumber(monthlyPropertyTax)) {
    return monthlyPropertyTax * 12;
  }

  return suggestedPurchasePrice * getCostForState(stateAbbr, 'statePropertyTax');
}